module.exports = __webpack_public_path__ + "img/bitmap_en.3ac9c92e.png";